import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-participant-profile',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './participant-profile.component.html',
  styleUrls: ['./participant.scss']
})
export class ParticipantProfileComponent {

}
